<template>
  <el-row class="digital-block" :style="getDiffStyle(4)">
    <el-row>
      <el-col :span="isFull?2:2"><el-row :class="blockData.icon"/></el-col>
      <el-col :span="isFull?9:10">
        <el-row class="screen-title">用{{blockData.typeName}}展示</el-row>
        <el-row class="title-underline"></el-row>
      </el-col>
    </el-row>
    <el-row :style="getDiffStyle(0)">
     <el-col :span="isFull?3:2" style="color: rgba(0,0,0,0)"> 1 </el-col>
      <el-col :span="isFull?18:20">
        <el-row :style="getDiffStyle(1)" class="corner-box">{{ checkLen(sourceData[blockData.valueProp[0]]) }}</el-row>
        <el-row style="color: #fff;">今日用{{blockData.typeName}}（{{checkLen(sourceData[blockData.valueProp[0]], true)}}）</el-row>
      </el-col>
      <el-col :span="isFull?3:2" style="color: rgba(0,0,0,0)"> 1 </el-col>
    </el-row>
    <el-row :style="getDiffStyle(0)">
      <el-col :span="isFull?13:13">
        <el-row :style="getDiffStyle(2)">{{ checkLen(sourceData[blockData.valueProp[1]]) }}</el-row>
        <el-row style="color: #fff;">上日同期（{{checkLen(sourceData[blockData.valueProp[1]], true)}}）</el-row>
      </el-col>
      <el-col :span="isFull?11:11">
        <el-row :style="getDiffStyle(2)">{{ sourceData[blockData.valueProp[2]] }}</el-row>
        <el-row style="color: #fff;">日环比</el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import CommonCharts from "../../common/chart/CommonCharts";
import buildBlockColumnConfig from "../../../config/chart/config_block_column";

export default {
  name: "DigitalBlock",
  components: {CommonCharts},
  props: ["blockIndex", "blockData", "sourceData", "isFull"],
  data() {
    return{
      dateTypes: [
        {index: 0, label: '日'},
        {index: 1, label: '月'},
        {index: 2, label: '年'}
      ],
      selDateType: 0,
      showUnit: '',
      timeStamp: 0
    }
  },
  methods: {
    dateSel(selIndex) {
      this.selDateType = selIndex;
      this.getSiteEnergyRank();
    },
    getDiffStyle(styleIndex) {
      if(this.isFull) {
        if(styleIndex === 0) return 'margin-top: 18px;font-size: 16px;'
        if(styleIndex === 1) return 'font-size: 48px;font-weight: bold;color: #FCB268;'
        if(styleIndex === 2) return 'font-size: 22px;color: #FCB268;'
        if(styleIndex === 3) return 'height: 168px;width: 280px;'
        if(styleIndex === 4) return 'padding-top: 16px;'
      }else {
        if(styleIndex === 0) return 'margin-top: 16px;font-size: 14px;'
        if(styleIndex === 1) return 'font-size: 36px;font-weight: bold;color: #FCB268;'
        if(styleIndex === 2) return 'font-size: 22px;color: #FCB268;'
        if(styleIndex === 3) return 'height: 128px;width: 265px;'
        if(styleIndex === 4) return 'padding-top: 10px;'
      }
    },
    checkLen(sValue, isUnit = false) {
      let res = parseFloat(sValue)
      if(!res) {
        if(isUnit) return this.blockData.unit
        else return sValue
      }else {
        if(res >= 10000) {
          if(isUnit) return '万' + this.blockData.unit;
          else return (res / 10000).toFixed(2)
        }else {
          if(isUnit) return this.blockData.unit;
          else return res
        }
      }
    }
  }
}
</script>

<style scoped>
  .digital-block{
    height: 228px;
    width: 283px;
    color: #15AEFE;
    padding: 0 20px 0 20px;
    margin: 0 0 16px 16px;
    background: url("../../../assets/images/digital-screen/digital-bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .triangle-top-right{
    width: 0;
    height: 0;
    border-top: 10px solid #00FFF8;
    border-left: 10px solid transparent;
  }
  .triangle-top-right-full{
    width: 0;
    height: 0;
    border-top: 16px solid #00FFF8;
    border-left: 16px solid transparent;
  }
  .date-line{
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
    margin-top: 10px;
  }
  .date-btn{
    width: 40px;
    height: 24px;
    border: 1px solid #12C5C0;
    border-radius: 2px;
    cursor: pointer;
    margin-left: 2px;
    background-color: #060A0E;
    color: #12C5C0;
  }
  .date-btn-sel{
    background-color: #12C5C0;
    color: #060A0E;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/DigitalScreen/DigitalBlock.vue